<app-tabs-main [selectedIndex]="1">
  <div newReservation class="flight-confirmation-container">
    <!-- Page heading, outside the ticket: title, greeting and intro on the page surface. -->
    <header class="confirmation-header">
      <div class="confirmation-header__row">
        <span class="confirmation-header__icon" aria-hidden="true"></span>
        <h1 class="confirmation-header__title">Confirmação do voo</h1>
      </div>
      <p class="confirmation-header__greeting">Prezado(a) {{ confirmation.crewName }},</p>
      <p id="trip-summary-title" class="confirmation-header__intro">Seguem dados da viagem solicitada:</p>
    </header>

    <!-- One photo ticket per direction (same frame, resolver and fallback as Meus Voos), each with the photo
         of its own destination: the leg and its date on the photo, codes, cities, times, the plane, the real
         connection stops, then the flights. -->
    <section class="trip-summary" aria-labelledby="trip-summary-title">
      @for (leg of legs; track leg.direction) {
        <article class="trip-leg" [attr.data-direction]="leg.direction">
          <app-flight-ticket-frame class="trip-leg__ticket" tone="active" [summary]="true"
            [stops]="leg.itinerary.stops" [connections]="leg.option.flightSegments.length - 1"
            [departureTime]="leg.schedule.departureTime" [arrivalTime]="leg.schedule.arrivalTime"
            [arrivesNextDay]="leg.schedule.arrivesNextDay" [connectionStops]="leg.schedule.connectionStops"
            [imageUrl]="legImageUrl(leg)" [imageAlt]="legImageAlt(leg)" [cityOf]="cityOf"
            (imageError)="onImageError($event)">
            <div ticketTopStart class="trip-leg__heading">
              <span class="trip-leg__kind" [class.trip-leg__kind--inbound]="leg.direction === 'VOLTA'">
                {{ confirmation.isRoundTrip() ? leg.direction : 'Somente ida' }}
              </span>
              <span class="trip-leg__date">
                <svg class="trip-leg__date-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                {{ leg.departure | dateFormat: 'DD/MM/YYYY' }}
              </span>
            </div>
            <div class="trip-leg__flights-row">
              <span class="trip-leg__flights-label">{{ leg.option.flightSegments.length > 1 ? 'Voos' : 'Voo' }}</span>
              <strong class="trip-leg__flights">{{ leg.flightNumbers }}</strong>
            </div>
          </app-flight-ticket-frame>
        </article>
      }
    </section>

    <section class="legal" aria-labelledby="legal-title">
      <div class="legal__heading">
        <span class="legal__icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8h.01M11 12h1v4h1"/></svg>
        </span>
        <h2 id="legal-title" class="legal__title">Informações importantes</h2>
      </div>
      <!-- Full legal copy, unchanged. The card grows with it; the action dock below stays clear of it. -->
      <div class="legal__scroll">
        <ul class="additional-information_list">
          <li>A emissão deste passe representa a intenção de voo, mas não garante: assento,
            embarque, benefícios e o embarque prioritário em relação a passageiros pagantes e
          funcionários LATAM.</li>
          <li>De acordo com os procedimentos vigentes do SNEA, para o uso do passe é obrigatório
            portar o uniforme completo da sua empresa e apresentar documento original com foto
          no momento do embarque.</li>
          <li>Bagagens fora do padrão estabelecido pela companhia deverão ser despachadas no check
          in.</li>
        </ul>
      </div>
    </section>

    <ng-template #loading>
      <div class="loading-container">
        <img src="../../../assets/images/plane-loading-100x100.gif" alt="Loading">
      </div>
    </ng-template>

    <!-- Same action dock as "Prosseguir": secondary action left, primary right, above the bottom nav. -->
    <div class="actions">
      <button class="btn btn-back" type="button" (click)="back()"><span aria-hidden="true">←</span> Retornar</button>
      <button class="btn btn-confirmation" type="button" (click)="confirmReservation()">Confirmar <span aria-hidden="true">→</span></button>
    </div>
  </div>
</app-tabs-main>
